window['$'] = window['jQuery'] = require("../../../static/js/jquery/jquery-1.12.4.min.js");
require("../../../static/js/jquery/jquery.browser.min.js");
require("../../../static/plugins/bootstrap/3.3.6/js/bootstrap.min.js");
require("../../../static/js/jquery/jquery.cookie.js");
require("../../../static/js/main.js");
require("../../../static/us/js/src/override/personalized-content.js");
window['Spinner'] = require("../../../static/js/spin.min.js");
require("../../../static/js/spinner.js");
